import * as React from 'react';
import { useGetFormByIdQuery } from 'src/services/api/formsApi';
import { NotificationContentBreadcrumbs } from 'src/components/Inbox/NotificationContentBreadcrumbs';

export const FormNotificationDetailsBreadcrumbs: React.FC<{
  formId: string;
  responseRefId: string;
  responderName: string;
}> = ({ formId, responseRefId, responderName }) => {
  const { data: formTemplate } = useGetFormByIdQuery(formId);

  const items = [
    { label: 'Forms', path: '/forms' },
    {
      label: formTemplate?.fields.name || '',
      path: `/forms/details?formId=${formId}&view=see_responses`,
    },
    {
      label: responderName,
      path: `/forms/submit?formId=${formId}&responseRefId=${responseRefId}`,
    },
  ];

  return <NotificationContentBreadcrumbs items={items} />;
};
